export default __webpack_public_path__ + "static/media/cave.1ea5a08a.svg";